import { Box, Checkbox, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import React from "react";
import { useBetween } from "use-between";
import { IDiameterCheckboxDropdown } from "../interfaces/diameter-checkbox-dropdown.interface";
import { ProductFiltersUseBetween } from "../use-between/product-filters-use-between";
import { Utils } from "../../../shared/constants/utilities.constants";
import { getDeletedOrAddedItem, getItemsAfterDelete, getItemsAfterInsert, returnSelectedItems } from "./diameter-checkbox.service";
import { border } from "../../../shared/dropdown/dropdown.service";

export interface ICheckboxDropdownInput {
  data: IDiameterCheckboxDropdown[];
  isFromDn: boolean;
}

const DiameterCheckboxDropdown: React.FC<ICheckboxDropdownInput> = ({data, isFromDn}): JSX.Element => {
  const { selectedNpsAndDnDiameter, setSelectedNpsAndDnDiameter } = useBetween(ProductFiltersUseBetween);
  const { setDiameterRangeFromTo } = useBetween(ProductFiltersUseBetween);
  const { diameterMin } = useBetween(ProductFiltersUseBetween);

  const updateDiameterMm = (selectedItems: IDiameterCheckboxDropdown[]): void => {
    if (selectedItems.length === 0) {
      setDiameterRangeFromTo([diameterMin, diameterMin]);
      setSelectedNpsAndDnDiameter(returnSelectedItems([data[0]]));
    } else if (selectedItems.length === 1) {
      setDiameterRangeFromTo([selectedItems[0].config.value, selectedItems[0].config.value]);
    } else {
      setDiameterRangeFromTo([selectedItems[0].config.value, selectedItems[selectedItems.length - 1].config.value]);
    }
  }

  const change = (selectedValues: IDiameterCheckboxDropdown[], isClear: boolean) => {
    let selectedItems: IDiameterCheckboxDropdown[] = [];
    if (!isClear) {
      const deleteItem: IDiameterCheckboxDropdown | null = getDeletedOrAddedItem(selectedNpsAndDnDiameter, selectedValues);
      const addedItem: IDiameterCheckboxDropdown | null = getDeletedOrAddedItem(selectedValues, selectedNpsAndDnDiameter);
      if (deleteItem) {
        selectedItems = getItemsAfterDelete(Utils.clone(selectedNpsAndDnDiameter), deleteItem);
        setSelectedNpsAndDnDiameter(selectedItems);
      } else if (addedItem) {
        selectedItems = getItemsAfterInsert(Utils.clone(data), Utils.clone(selectedNpsAndDnDiameter), addedItem);
        setSelectedNpsAndDnDiameter(selectedItems);
      }
    }
    else {
      setSelectedNpsAndDnDiameter(selectedItems);
    }
    updateDiameterMm(selectedItems);
  }

  const isSelected = (option: IDiameterCheckboxDropdown): boolean => {
    return selectedNpsAndDnDiameter.some(x => x.index === option.index);
  }

  return (
    <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      options={data}
      isOptionEqualToValue={(option, value) => option.index === value.index}
      disableCloseOnSelect
      style={{ width: '300px' }}
      value={selectedNpsAndDnDiameter}
      getOptionLabel={option => isFromDn ? option.config.value.toString() : option.config.name}
      onChange={(_, values, reason) => {
        change(values, reason === 'clear');
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            border: {border},
            padding: "10px"
          },
          "&.Mui-focused fieldset": {
            border: {border},
          },
          "&:hover fieldset": {
            border: {border},
          },
        },
        "& .MuiAutocomplete-input": {
          padding: "0px !important"
        },
      }}
      renderOption={(props, option) => ( 
        <Box component={"li"} {...props}>
          <Checkbox
            sx={{
              "&.Mui-checked": {
                  color: "#821818"
              }
            }}
            checked={isSelected(option)}
          />
          {isFromDn ? option.config.value.toString() : option.config.name }
        </Box>
      )}
      renderInput={(params) => 
        (<TextField {...params} />
      )}
    />
  );
}
export default DiameterCheckboxDropdown;